import {StyleSheet} from 'react-native'
import {FullButton} from '../common';
import {openInbox} from 'react-native-email-link';


interface Props {
  installEsimText: string,
  installEsimAction: Function,
  goToMailBoxText: string,
  goToMailBoxAction: Function,
  isLoading: boolean,
  externalStyle: Object,
}

const styles = getStyles();

export default function InstallEsimButton(props: Props) {
        
    // iOS or Android < 13 -> render 'Go to mailbox' button only
    return (
        <FullButton
            style={[styles.fullButtonStyle, props.externalStyle]}
            onPress={props.goToMailBoxAction ? () => props.goToMailBoxAction() : () => openInbox()}
            text={props.goToMailBoxText}
            isLoading={props.isLoading}
        />
    );
}

function getStyles() {
  return StyleSheet.create({
    fullButtonStyle: {
      marginBottom: 20,
      marginHorizontal: 20,
      fontSize: 14,
    },
  });
}